import { clsx } from 'clsx';

import GiftSvg from 'Shared/svg/gift.svg';

type PropsT = {
  isDisabled?: boolean;
};

export const GiftIcon: React.FunctionComponent<PropsT> = ({ isDisabled }) => {
  return (
    <span
      className={clsx(
        'rounded-full p-10',
        isDisabled
          ? 'bg-black-20 dark:bg-black-40'
          : 'bg-blue-80 dark:bg-blue-70',
      )}
    >
      <GiftSvg className="size-28 text-share-card-bg-2" />
    </span>
  );
};
